export function isLoggedBackend() {
    // Cookie AuthorizationGoatech durata 1 anno
    if (document.cookie.split(';').some((item) => item.trim().startsWith('AuthorizationGoatech='))) {
        return true;
    }
    return false;
}